import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../shared/services/api.service';
import { LocalAccountService } from '../shared/services/localAccount.service';


@Injectable({
  providedIn: 'root'
})
export class SoftskillCategoryService implements Resolve<any> {

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if ((state.url.includes('common-area') && state.url.includes('subscription/') && state.url.includes('/detail')) ||
      (state.url.includes('administration-area') && state.url.includes('subjects/') && state.url.includes('/subscription/'))
    ) {
      try {
        const resolved: any = {};
        let subscriptionResponse: any;
        if (this.localAccountService.isAdmin() || this.localAccountService.isOperator()) {
          // subscriptionResponse = await this.getSubscription(route.params.subscriptionId);
        } else {
          // subscriptionResponse = await this.getSubscriptionAllowed(route.params.subscriptionId);
        }
        resolved.subscription = subscriptionResponse.payload;
        if (route.params.subjectId) {
          // const subjectResponse: any = await this.getSubject(route.params.subjectId);
          // resolved.subject = subjectResponse.payload;
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else {
      try {
        const resolved: any = {};
        // if (route.params.degreeCourseId == 'new') {
        //   return resolved;
        // } else {
        // const degreeCourseResponse: any = await this.getDegreeCourse(route.params.degreeCourseId);
        // resolved.degreeCourse = degreeCourseResponse.payload;
        if (route.params.softskillCategoryId && !(route.params.softskillCategoryId === 'new')) {
          const subjectResponse: any = await this.getSoftskillCategory(route.params.softskillCategoryId);
          resolved.softskillCategory = subjectResponse.payload;
        }
        return resolved;
        // }
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    }
  }

  constructor(private api: ApiService, private localAccountService: LocalAccountService, private router: Router) {

  }

  retrieveSoftskillCategories(filterString, pageIndex, pageSize, sortField, sortDirection) {
    if (!filterString) {
      filterString = ''
    };
    if (!pageIndex) {
      pageIndex = 0
    }
    if (!pageSize) {
      pageSize = 10
    }
    return this.api.getRequestPromise(`softskillcategory/paged?filterString=${filterString}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`);
  }

  getSoftskillCategories() {
    return this.api.getRequestPromise("softskillcategory/list");
  }

  getAllowedSoftskillCategories() {
    // return this.api.getRequestPromise("public/wp/softskillcategories");
    return this.api.getRequestPromise("public/softskillcategories");
  }

  getSoftskillCategoriesForEstimation() {
    return this.api.getRequestPromise("softskillcategory/list/forEstimation");
  }

  deactivateCategory(id) {
    return this.api.putRequestPromise(`softskillcategory/${id}/deactivate`, {});
  }

  activateCategory(id) {
    return this.api.putRequestPromise(`softskillcategory/${id}/activate`, {});
  }

  deleteCategory(id) {
    return this.api.deleteRequestPromise(`softskillcategory/${id}/delete`);
  }

  async getSoftskillCategory(id) {
    return this.api.getRequestPromise(`softskillcategory/${id}`);
  }

  async createSoftskillCategory(obj) {
    return this.api.postRequestPromise(`softskillcategory`, obj);
  }

  async editSoftskillCategory(obj) {
    return this.api.putRequestPromise(`softskillcategory`, obj);
  }

}
